/** Safari has no requestIdleCallback; there the work waits this long instead. */
const IDLE_FALLBACK_MS = 3000

/** Runs `callback` once the browser has nothing more urgent to do, at the latest after `timeoutMs`. */
export const runWhenIdle = (callback: () => void, timeoutMs = IDLE_FALLBACK_MS): void => {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, { timeout: timeoutMs })
  } else {
    setTimeout(callback, timeoutMs)
  }
}

/** Runs `callback` when idle after the page has finished loading. */
export const runWhenIdleAfterLoad = (callback: () => void): void => {
  if (document.readyState === 'complete') {
    runWhenIdle(callback)
  } else {
    window.addEventListener('load', () => runWhenIdle(callback), { once: true })
  }
}
